import { createSlice } from '@reduxjs/toolkit';

export const AttendeeRegistrationSlice = createSlice({
  name: 'attendeeRegistration',
  initialState: {
    attendeeId: '',
    attendeeAccountNumber: '',
    attendeeName: '',
    attendeePhone: '',
    attendeeEmail: '',
    isRegistered: false,
  },
  reducers: {
    setAttendeeRegistration: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setAttendeeRegistration } = AttendeeRegistrationSlice.actions;
export default AttendeeRegistrationSlice.reducer;
